import "../../assets/main.css";
import "ahoy.js";
import { Application } from "@hotwired/stimulus";
import TrackingController from "../stimulus/tracking_controller";
import initializeApp from "../initialize_inertia";

const stimulus = Application.start();
stimulus.debug = false;
stimulus.register("tracking", TrackingController);

initializeApp();
